/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.directive.relatedProgramTemplates'
])

.controller('ResourcesController', ['$scope', '$state', '$timeout', '$log', 'ApiService', 'HelpersService', 'ValidateService', function($scope, $state, $timeout, $log, ApiService, HelpersService, ValidateService) {

  $scope.resources = {

    init: function() {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Resource Templates',
        buttonRight: {
          label: '+ Create Template',
          action: function() {
            $state.go('application.resources.create');
          }
        }
      });
      this.getTemplates();
      // Subscribe to listeners
      $scope.$on('ResourcesCreateController::success', function() {
        $scope.resources.getTemplates();
      });

      $scope.$on('ResourcesUpdateTemplate::success', function() {
        $scope.resources.getTemplates();
      });
    },

    removeIndex: -1,
    showErrors: false,
    errorTimer: false,

    errors: {},

    model: {
      templates: []
    },

    getTemplates: function() {
      ApiService.resource.list().then(this.success.getTemplates, this.error.getTemplates);
    },

    removeTemplate: function(id, index) {
      this.removeIndex = index;
      ApiService.resource.remove(id).then(this.success.removeTemplate, this.error.removeTemplate);
    },

    // Success Callbacks for all requests
    success: {

      getTemplates: function(response, status, headers, config) {
        $scope.resources.showErrors = false;
        $scope.resources.model.templates = response.data.summaries;
      },

      removeTemplate: function(response, status, headers, config) {
        $scope.resources.showErrors = false;
        if ($scope.resources.removeIndex !== -1) {
          $scope.resources.model.templates.splice($scope.resources.removeIndex, 1);
          $scope.resources.removeIndex = -1;
        }
      }
    },

    // Error Callbacks for all requests
    error:  {

      getTemplates: function(response, status, headers, config) {
        //TODO: Need to handle this
      },

      removeTemplate: function(response, status, headers, config) {
        //TODO: Need to handle this
        console.log('removeTemplate: ', $scope.resources.removeIndex);
        $scope.resources.showErrors = true;
        $scope.resources.errors[$scope.resources.removeIndex] = [{
          message: "Unable to remove: " + $scope.resources.model.templates[$scope.resources.removeIndex].name
        }];

        switch(response.status) {
          case 402:
            $scope.resources.errors[$scope.resources.removeIndex].push({
              message: "Template is in use."
            });
            break;
        }

        $scope.resources.errorTimer = $timeout(function() {
          $scope.resources.showErrors = false;
          $scope.resources.errors[$scope.resources.removeIndex] = {};
          $scope.resources.removeIndex = -1;
        }, 5000);

      }
    }

  };

  $scope.resources.init();


}]);